module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Deadline-Gallipoli.aaf274f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Deadline-Gallipoli.jpg
// module id = NDbG
// module chunks = 0